import { createContext } from "react";
import { BidComparisonCalculationContextProps } from "../types";

const BidComparisonCalculationContext = createContext<BidComparisonCalculationContextProps>({});

BidComparisonCalculationContext.displayName = "BidComparisonCalculationContext";

export { BidComparisonCalculationContext };
